import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  books: hasMany('book-library/book'),
  teacher: belongsTo(),
})
